import React from 'react';
import { Create, Edit, SimpleForm, TextInput, SelectInput, DateField, ReferenceInput } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { ONBOARDING_STATUS, CONTRACT_ALERT_TYPES, CONTRACT_ALERT_STATUS, DOCUMENT_TYPES, DOCUMENT_STATUS, CONTRACT_TYPES, CONTRACT_STATUS } from './constants';

export const OnboardingProcessCreate = () => (
  <Create>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Onboarding Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <TextInput source="processId" label="Process ID" fullWidth />
        <ReferenceInput source="employee.id" reference="employees" fullWidth>
          <SelectInput optionText="name" label="Employee" />
        </ReferenceInput>
        <TextInput source="department" fullWidth />
        <DateField source="initiatedAt" label="Initiated At" />
        <DateField source="targetStartDate" label="Target Start Date" />
        <SelectInput source="status" choices={ONBOARDING_STATUS.map(s => ({ id: s, name: s }))} fullWidth defaultValue="InProgress" />
      </Box>
    </SimpleForm>
  </Create>
);

export const OnboardingProcessEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Onboarding Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <TextInput source="processId" label="Process ID" fullWidth />
        <ReferenceInput source="employee.id" reference="employees" fullWidth>
          <SelectInput optionText="name" label="Employee" />
        </ReferenceInput>
        <TextInput source="department" fullWidth />
        <SelectInput source="status" choices={ONBOARDING_STATUS.map(s => ({ id: s, name: s }))} fullWidth />
        <DateField source="initiatedAt" label="Initiated At" />
        <DateField source="targetStartDate" label="Target Start Date" />
        <DateField source="completedAt" label="Completed At" />
      </Box>
    </SimpleForm>
  </Edit>
);

export const ContractAlertCreate = () => (
  <Create>
    <SimpleForm>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <TextInput source="alertId" label="Alert ID" fullWidth />
        <ReferenceInput source="employee.id" reference="employees" fullWidth>
          <SelectInput optionText="name" label="Employee" />
        </ReferenceInput>
        <SelectInput source="alertType" choices={CONTRACT_ALERT_TYPES.map(t => ({ id: t, name: t }))} fullWidth />
        <SelectInput source="status" choices={CONTRACT_ALERT_STATUS.map(s => ({ id: s, name: s }))} fullWidth defaultValue="Pending" />
        <DateField source="triggerDate" label="Trigger Date" />
        <DateField source="alertSentAt" label="Alert Sent At" />
      </Box>
      <TextInput source="actionRequired" multiline fullWidth />
    </SimpleForm>
  </Create>
);

export const ContractAlertEdit = () => (
  <Edit>
    <SimpleForm>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <TextInput source="alertId" label="Alert ID" fullWidth />
        <ReferenceInput source="employee.id" reference="employees" fullWidth>
          <SelectInput optionText="name" label="Employee" />
        </ReferenceInput>
        <SelectInput source="alertType" choices={CONTRACT_ALERT_TYPES.map(t => ({ id: t, name: t }))} fullWidth />
        <SelectInput source="status" choices={CONTRACT_ALERT_STATUS.map(s => ({ id: s, name: s }))} fullWidth />
        <DateField source="triggerDate" label="Trigger Date" />
        <DateField source="alertSentAt" label="Alert Sent At" />
        <DateField source="actionTakenAt" label="Action Taken At" />
      </Box>
      <TextInput source="actionRequired" multiline fullWidth />
      <TextInput source="actionTakenBy" label="Action Taken By" fullWidth />
    </SimpleForm>
  </Edit>
);
